import React, { ReactNode, useState } from 'react';

type IAppSettingsContext = {
	rounding: string;
	changeRounding: (rounding: string) => void;
	realizationStatus: string;
	changeRealizationStatus: (realizationStatus: string) => void;
};

const AppSettingsContext = React.createContext<IAppSettingsContext>({
	rounding: localStorage.getItem('appSettings.rounding') ?? 'm', // Valeur par défaut
	changeRounding: () => {
		null;
	},
	realizationStatus: localStorage.getItem('appSettings.realizationStatus') ?? 'all', // Valeur par défaut
	changeRealizationStatus: () => {
		null;
	},
});

export const useAppSettings = () => {
	return React.useContext(AppSettingsContext);
};

type AppSettingsProviderProps = {
	children?: ReactNode;
};

const AppSettingsProvider: React.FC<AppSettingsProviderProps> = ({ children }) => {
	const [rounding, setRounding] = useState(localStorage.getItem('appSettings.rounding') ?? 'm');
	const changeRounding = (rounding: string) => {
		setRounding(rounding);
		localStorage.setItem('appSettings.rounding', rounding);
	};

	const [realizationStatus, setRealizationStatus] = useState(
		localStorage.getItem('appSettings.realizationStatus') ?? 'all',
	);
	const changeRealizationStatus = (realizationStatus: string) => {
		setRealizationStatus(realizationStatus);
		localStorage.setItem('appSettings.realizationStatus', realizationStatus);
	};

	const contextValue = React.useMemo(() => {
		return {
			rounding,
			changeRounding,
			realizationStatus,
			changeRealizationStatus,
		};
	}, [rounding, realizationStatus]);

	return <AppSettingsContext.Provider value={contextValue}>{children}</AppSettingsContext.Provider>;
};

export default AppSettingsProvider;
